import { all } from 'redux-saga/effects'
import { RsvpsFetchSaga, RsvpCountFetchSaga } from '../sagas/store/rsvp.saga'


export default function* root() {
    yield all([
        RsvpsFetchSaga(),
        RsvpCountFetchSaga()
    ])
}